import { Store } from './Store';

export const dataStore = new Store();

// @ts-ignore
window.dataStore = dataStore;
